import { QueryClientProvider } from '@tanstack/react-query';
import { Outlet } from 'react-router-dom';
import { Toaster } from 'sonner';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';

import { Maintenance } from '@ballerine/ui';

import { env } from '@/common/env/env';
import { queryClient } from '@/lib/react-query/query-client';

export function App() {
  const isUnderMaintenance = env.VITE_BACKEND_UNDER_MAINTENANCE;

  if (isUnderMaintenance) {
    return <Maintenance />;
  }

  return (
    <QueryParamProvider adapter={ReactRouter6Adapter}>
      <QueryClientProvider client={queryClient}>
        <Outlet />
        <Toaster richColors />
      </QueryClientProvider>
    </QueryParamProvider>
  );
}
